import React, { useState, useEffect } from 'react';
import SplashScreen from './components/SplashScreen';
import PhoneAuth from './components/PhoneAuth';
import TakeawayGym from './components/TakeawayGym';

// --- Main App Component ---
export default function App() {
    const [currentView, setCurrentView] = useState('splash');

    useEffect(() => {
        const timer = setTimeout(() => {
            // Changed from 'chatbot' to 'gym' to go directly to TakeawayGym
            setCurrentView('phone');
        }, 5000);
        return () => clearTimeout(timer);
    }, []);

    const handlePhoneComplete = ({ phone }) => {
        // Phone number captured — proceed to the main gym screen
        // You can store `phone` in context / state manager here if needed
        console.log('User phone:', phone);
        setCurrentView('gym');
    };

    const renderView = () => {
        switch (currentView) {
            case 'splash':
                return <SplashScreen />;
            case 'phone':
                return <PhoneAuth onComplete={handlePhoneComplete} />;
            case 'gym':
            default:
                // Now defaults to TakeawayGym instead of Chatbot
                return <TakeawayGym />;
        }
    };

    return (
        <div style={styles.appContainer}>
            {renderView()}
        </div>
    );
}

// --- Styles ---
const styles = {
    appContainer: {
        fontFamily: "'Helvetica Neue', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', sans-serif",
        backgroundColor: '#f0f2f5',
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#333',
    },
};